export const TIME_OPTIONS = [
  { lookup_key: '00:00', lookup_value: '00:00' },
  { lookup_key: '01:00', lookup_value: '01:00' },
  { lookup_key: '02:00', lookup_value: '02:00' },
  { lookup_key: '03:00', lookup_value: '03:00' },
  { lookup_key: '04:00', lookup_value: '04:00' },
  { lookup_key: '05:00', lookup_value: '05:00' },
  { lookup_key: '06:00', lookup_value: '06:00' },
  { lookup_key: '07:00', lookup_value: '07:00' },
  { lookup_key: '08:00', lookup_value: '08:00' },
  { lookup_key: '09:00', lookup_value: '09:00' },
  { lookup_key: '10:00', lookup_value: '10:00' },
  { lookup_key: '11:00', lookup_value: '11:00' },
  { lookup_key: '12:00', lookup_value: '12:00' },
  { lookup_key: '13:00', lookup_value: '13:00' },
  { lookup_key: '14:00', lookup_value: '14:00' },
  { lookup_key: '15:00', lookup_value: '15:00' },
  { lookup_key: '16:00', lookup_value: '16:00' },
  { lookup_key: '17:00', lookup_value: '17:00' },
  { lookup_key: '18:00', lookup_value: '18:00' },
  { lookup_key: '19:00', lookup_value: '19:00' },
  { lookup_key: '20:00', lookup_value: '20:00' },
  { lookup_key: '21:00', lookup_value: '21:00' },
  { lookup_key: '22:00', lookup_value: '22:00' },
  { lookup_key: '23:00', lookup_value: '23:00' },
];

export const SCHEDULE_OPTIONS = [
  {
    checked: null,
    lookup_code: null,
    lookup_key: '0',
    lookup_value: 'Daily',
    param_key: 'send_options',
    sort_key: 0,
  },
  {
    checked: null,
    lookup_code: null,
    lookup_key: '1',
    lookup_value: 'Weekly',
    param_key: 'send_options',
    sort_key: 1,
  },
  {
    checked: null,
    lookup_code: null,
    lookup_key: '2',
    lookup_value: 'Monthly',
    param_key: 'send_options',
    sort_key: 2,
  },
];

export const DAY_OF_MONTH_OPTIONS = [
  { lookup_key: '1', lookup_value: '1' },
  { lookup_key: '2', lookup_value: '2' },
  { lookup_key: '3', lookup_value: '3' },
  { lookup_key: '4', lookup_value: '4' },
  { lookup_key: '5', lookup_value: '5' },
  { lookup_key: '6', lookup_value: '6' },
  { lookup_key: '7', lookup_value: '7' },
  { lookup_key: '8', lookup_value: '8' },
  { lookup_key: '9', lookup_value: '9' },
  { lookup_key: '10', lookup_value: '10' },
  { lookup_key: '11', lookup_value: '11' },
  { lookup_key: '12', lookup_value: '12' },
  { lookup_key: '13', lookup_value: '13' },
  { lookup_key: '14', lookup_value: '14' },
  { lookup_key: '15', lookup_value: '15' },
  { lookup_key: '16', lookup_value: '16' },
  { lookup_key: '17', lookup_value: '17' },
  { lookup_key: '18', lookup_value: '18' },
  { lookup_key: '19', lookup_value: '19' },
  { lookup_key: '20', lookup_value: '20' },
  { lookup_key: '21', lookup_value: '21' },
  { lookup_key: '22', lookup_value: '22' },
  { lookup_key: '23', lookup_value: '23' },
  { lookup_key: '24', lookup_value: '24' },
  { lookup_key: '25', lookup_value: '25' },
  { lookup_key: '26', lookup_value: '26' },
  { lookup_key: '27', lookup_value: '27' },
  { lookup_key: '28', lookup_value: '28' },
  { lookup_key: '29', lookup_value: '29' },
  { lookup_key: '30', lookup_value: '30' },
  { lookup_key: '31', lookup_value: '31' },
];

export const DAY_OF_WEEK_OPTIONS = [
  { lookup_key: '1', lookup_value: 'Monday' },
  { lookup_key: '2', lookup_value: 'Tuesday' },
  { lookup_key: '3', lookup_value: 'Wednesday' },
  { lookup_key: '4', lookup_value: 'Thursday' },
  { lookup_key: '5', lookup_value: 'Friday' },
  { lookup_key: '6', lookup_value: 'Saturday' },
  { lookup_key: '0', lookup_value: 'Sunday' },
];
